import React, { useState, useCallback, useEffect, useImperativeHandle } from "react";
import { BULK_ACTION_FIELD } from "../HyroTable.consts";
import CheckBoxOutlineBlankIcon from "@mui/icons-material/CheckBoxOutlineBlank";
import IndeterminateIcon from "src/icons/CheckboxIndeterminateIcon";
import FilledCheckbox from "src/icons/FilledCheckbox";

export default function useRowSelection({
  apiRef,
  enableBulkEdit,
  onRowSelectionModelChange
}, ref) {
  const [hasSelectedRows, setHasSelectedRows] = useState(false);

  const selectedRows = apiRef.current?.getSelectedRows ? Array.from(apiRef.current?.getSelectedRows()?.keys()) : [];

  const handleRowSelectionModelChange = useCallback((selection) => {
    setHasSelectedRows(selection.length > 0);
    onRowSelectionModelChange?.(selection);
  }, [onRowSelectionModelChange]);

  const setSelectedRows = useCallback((rows) => {
    apiRef.current.setRowSelectionModel(rows);
  }, [apiRef]);

  const clearSelection = useCallback(() => {
    apiRef.current.setRowSelectionModel([]);
    setHasSelectedRows(false);
  }, [apiRef]);

  useEffect(() => {
    apiRef.current.setRowSelectionModel([]);
    setHasSelectedRows(false);
  }, [enableBulkEdit, apiRef]);

  useEffect(() => {
    const leaveBulkActionView = (event) => {
      if (event.colDef.field === BULK_ACTION_FIELD) return;
      clearSelection();
    };

    const unsubscribeColumnHeaderClick = apiRef.current.subscribeEvent("columnHeaderClick", (e) => leaveBulkActionView(e, true));
    const unsubscribeCellClick = apiRef.current.subscribeEvent("cellClick", leaveBulkActionView);

    return () => {
      unsubscribeColumnHeaderClick();
      unsubscribeCellClick();
    };
  }, [apiRef, enableBulkEdit, clearSelection]);

  useImperativeHandle(ref, () => ({
    getSelectedRows: () => selectedRows,
    setSelectedRows
  }));

  const baseCheckbox = {
    disableRipple: true,
    icon: <CheckBoxOutlineBlankIcon />,
    checkedIcon: <FilledCheckbox />,
    indeterminateIcon: <IndeterminateIcon />,
    sx: {
      "& svg": {
        width: "20px",
        height: "20px"
      }
    }
  };

  return {
    hasSelectedRows,
    selectedRows,
    handleRowSelectionModelChange,
    clearSelection,
    baseCheckbox
  };
}
